import { styled } from "styled-components";

export const ReviewsSections = styled.div<{
  $column?: boolean;
  $altStyling?: boolean;
}>`
  display: flex;
  justify-content: ${({ $column }) => ($column ? "center" : "start")};
  gap: 12px;
  align-items: center;
  color: ${({ theme, $altStyling }) =>
          $altStyling ? theme.colors.primary[50] : theme.colors.default[400]};

  ${({ theme }) => theme.breakpoints.md.query} {
    flex-direction: column;
    justify-content: center;
    align-items: ${({ $column }) => ($column ? "center" : "flex-start")};
    gap: 4px;
  }
`;

export const ReviewersSection = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  fontsize: 14px;
  flex-shrink: 0;
`;

export const ReviewersIcons = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  height: 21px;
  width: 86px;
`;

export const StarRating = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;
